import { Injectable } from '@angular/core';
import S3 from 'aws-sdk/clients/s3';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class UploadS3Service {
    constructor() {}
    uploadFile(file: any, filePath: any) {
        return new Promise((resolve, reject) => {
            const contentType = file.type;
            const bucket = new S3({
                accessKeyId: `${environment.AWS_ACCESS_KEY_ID}`, // ACCESS_KEY_ID
                secretAccessKey: `${environment.AWS_SECRET_ACCESS_KEY}`, // SECRET_ACCESS_KEY
                region: 'us-east-2', // BUCKET_REGION
            });
            const params = {
                Bucket: 'dinengo', //BUCKET_NAME
                Key: filePath,
                Body: file,
                ACL: 'public-read',
                ContentType: contentType,
            };
            bucket.upload(params, function (err: any, data: any) {
                if (err) {
                    reject(err);
                }
                resolve(data);
            });
        });
    }

    deleteFile(filePath: any) {
        return new Promise((resolve, reject) => {
            const bucket = new S3({
                accessKeyId: `${environment.AWS_ACCESS_KEY_ID}`, // ACCESS_KEY_ID
                secretAccessKey: `${environment.AWS_SECRET_ACCESS_KEY}`, // SECRET_ACCESS_KEY
                region: 'us-east-2', // BUCKET_REGION
            });
            const params = {
                Bucket: 'dinengo',
                Key: filePath
            };
            bucket.deleteObject(params, function (err: any, data: any) {
                if (err) {
                    reject(err);
                }
                resolve(data);
            });
        });
    }
}
